import React from 'react';
import {Typography, Box, Button, TextField, Card, CardContent, Slider, InputAdornment, Grid, FormControlLabel, Checkbox, Divider} from '@material-ui/core/';
// import InfoIcon from '@material-ui/icons/Info';

class CurrentPartnerCalculator extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            ordersPerWeek:"",
            avgCostPerOrder: "",
            percentForDelivery: "",
            commissionInPastWeek:"",
            submitted: false,

            monthsToShow:1,
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.calculateCommissionFromFormula = this.calculateCommissionFromFormula.bind(this);
        this.calculatePercentSalesFromFormula = this.calculatePercentSalesFromFormula.bind(this);
    }

    handleSubmit(event){
        event.preventDefault()
        this.setState({submitted:true})
    }

    calculateCommissionFromFormula(){
        let commissionForDelivery = this.state.ordersPerWeek * this.state.avgCostPerOrder * this.state.percentForDelivery * .01 * .3;
        let commissionForPickup = this.state.ordersPerWeek * this.state.avgCostPerOrder * (1 - this.state.percentForDelivery *.01) * .2;
        return (commissionForPickup + commissionForDelivery).toLocaleString(undefined, {maximumFractionDigits:2});
    }

    calculatePercentSalesFromFormula(){
        let commissionForDelivery = this.state.ordersPerWeek * this.state.avgCostPerOrder * this.state.percentForDelivery * .01 * .3;
        let commissionForPickup = this.state.ordersPerWeek * this.state.avgCostPerOrder * (1 - this.state.percentForDelivery *.01) * .2;
        return ((commissionForDelivery + commissionForPickup)/(this.state.ordersPerWeek * this.state.avgCostPerOrder) * 100).toFixed(2)
    }

    render(){
        //Orders per Week
        //Average total per order
        //Estimated percentage of orders that are for delivery

        return(
        <div>
            <Box p={5}>
            <Typography variant='h3' gutterBottom>GrubHub Commission Calculator</Typography>
            <Card>
            <CardContent>
            <Typography variant='h5' gutterBottom>We'll help you visualize just how much GrubHub is slicing into your profits.</Typography>
            <Box m={5}>
            <form noValidate autoComplete="off" onSubmit={this.handleSubmit}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField 
                        value={this.state.ordersPerWeek}
                        onChange={(event) => this.setState({submitted:false, ordersPerWeek: event.target.value})}
                        label="Orders Per Week"
                        type="number"
                        variant="outlined"
                        style ={{width: '25%'}}>
                    </TextField>
                </Grid>
                <Grid item xs={12}>
                    <TextField 
                        value={this.state.avgCostPerOrder}
                        onChange={(event) => this.setState({submitted:false, avgCostPerOrder: event.target.value})}
                        label="Average Cost Per Order"
                        type="number"
                        variant="outlined"
                        style ={{width: '25%'}}
                        InputProps={{startAdornment:(<InputAdornment position="start">$</InputAdornment>),}}>
                    </TextField>
                </Grid>
                <Grid item xs={12}>
                    <TextField 
                        value={this.state.percentForDelivery}
                        onChange={(event) => {this.setState({submitted:false, percentForDelivery: event.target.value})}}
                        label="% Of Orders For Delivery"
                        type="number"
                        variant="outlined"
                        style ={{width: '25%'}}
                        error={this.state.percentForDelivery < 0 || this.state.percentForDelivery > 100}
                        helperText={this.state.percentForDelivery < 0 || this.state.percentForDelivery > 100 ? 'Percentage Invalid!' : ''}>
                    </TextField>
                </Grid>
                <Grid item xs={12}>
                    <TextField 
                        value={this.state.commissionInPastWeek}
                        onChange={(event) => {this.setState({submitted:false, commissionInPastWeek: event.target.value})}}
                        label="Commission Paid in Past Week"
                        type="number"
                        variant="outlined"
                        style ={{width: '25%'}}
                        InputProps={{startAdornment:(<InputAdornment position="start">$</InputAdornment>),}}>
                    </TextField>
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={<Checkbox value="allowExtraEmails" color="primary" />}
                        label="Share my data with Gig Workers Collective and help expose GrubHub's true commissions and fees."
                    />
                </Grid>
                <Grid item xs={12}>
                    <Button type="submit" variant="contained" color="primary">Calculate</Button>
                </Grid>
            </Grid>
            </form>
            </Box>
            </CardContent>
            </Card>
            {
            this.state.submitted && 
            <Box mt={2}>
            <Typography variant='h3' gutterBottom>Your Results:</Typography>
            <Typography style={{ marginTop: 16, marginBottom: 16 }} variant='h5' gutterButton align='left'>Based on GrubHub's <a href='https://learn.grubhub.com/wp-content/uploads/2018/08/Grubhub_One-Pager_Pricing-Overview_Final.pdf'>publicized formula</a>, you should have paid <strong>${this.calculateCommissionFromFormula()}</strong>, or <strong>{this.calculatePercentSalesFromFormula()}%</strong> of last week's sales in commissions.</Typography>
            <Divider />
            <Typography style={{ marginTop: 16, marginBottom: 16 }} variant='h5' gutterBottom align='left'>In reality, GrubHub commissions cut into <strong>{(this.state.commissionInPastWeek / (this.state.ordersPerWeek * this.state.avgCostPerOrder) * 100).toFixed(2)}%</strong> of your sales.</Typography>
            <Divider />
            <Typography style={{ marginTop: 16, marginBottom: 16 }} variant='h5' gutterBottom align='left'>If this continues, over <strong>{this.state.monthsToShow}</strong> {this.state.monthsToShow === 1 ? 'month' : 'months'}, you can expect to pay <strong>${(this.state.commissionInPastWeek*4*this.state.monthsToShow).toLocaleString(undefined, {maximumFractionDigits:2})}</strong> in commissions.</Typography>
            <Divider />
            <Typography style={{ marginTop: 16, marginBottom: 16 }} variant='h5' gutterBottom align='left'>This means that on average, GrubHub takes a cut of <strong>${(this.state.commissionInPastWeek / this.state.ordersPerWeek).toFixed(2)}</strong> out of each order that you make, including those not for delivery.</Typography>
            <Divider />
            <Typography variant='h6' gutterBottom>
            Adjust Number of Months
            </Typography>
            <Slider
                value={this.state.monthsToShow}
                onChange={(event, newValue) => {this.setState({monthsToShow: newValue})}}
                defaultValue={12}
                valueLabelDisplay="auto"
                step={1}
                marks
                min={1}
                max={60}
            />
            </Box>
            }
            </Box>
        </div>
        );
    }
}

export default CurrentPartnerCalculator;